import { Box, Tab, styled } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import { useTranslation } from 'react-i18next';
import { IStyledProps, tabPanelProps } from '../SingleClient/SingleClient';

const SingleTab = styled(Tab)<IStyledProps>(({ theme, isrtl }) => ({
  minHeight: '34px',
  padding: '8px 0',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  alignItems: 'center',
  fontFamily: 'Satoshi',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '18px',
  color: theme.palette.primary.main,
  '&.Mui-selected': {
    fontWeight: 700,
    transition: 'font-weight 0.2s ease-in-out',
    background:
      'linear-gradient(138deg, rgba(101, 153, 165, 0.15) 24.11%, rgba(59, 102, 126, 0.15) 83.2%), #FFF',
    '& span': {
      background: 'linear-gradient(138deg, #6599A5 24.11%, #3B667E 83.2%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
  },
  '&:not(:first-of-type)': {
    borderLeft: isrtl ? 'none' : '0.5px solid #7CAEBE',
    borderRight: isrtl ? '0.5px solid #7CAEBE' : 'none',
  },
}));

type ISpeechToTextTabsProps = {
  value: number;
  setValue: (_value: number) => void;
};

function SpeechToTextTabs({ value, setValue }: ISpeechToTextTabsProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const tabsProperties = [
    {
      label: 'notes.suggestions',
    },
    {
      label: 'notes.recordings',
    },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      borderRadius="10px"
      border="0.5px solid #7CAEBE"
      justifyContent="center"
      mt={3}
      mb={value === 0 ? 2 : 1}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        centered
        variant="fullWidth"
        sx={{
          width: '100%',
          minHeight: '34px',
          '& .MuiTabs-indicator': {
            display: 'none',
          },
        }}
      >
        {tabsProperties.map(
          (
            singleTab: {
              label: string;
            },
            index
          ) => (
            <SingleTab
              key={singleTab.label}
              label={<span>{t(singleTab.label)}</span>}
              isrtl={language.split('-')[0] === 'ar'}
              sx={{
                borderRadius: () => {
                  if (index === 0) {
                    return language.split('-')[0] === 'ar' ? '0 10px 10px 0' : '10px 0 0 10px';
                  }
                  if (index === tabsProperties.length - 1) {
                    return language.split('-')[0] === 'ar' ? '10px 0 0 10px' : '0 10px 10px 0';
                  }
                  return '0';
                },
              }}
              {...tabPanelProps(index)}
            />
          )
        )}
      </Tabs>
    </Box>
  );
}

export default SpeechToTextTabs;
